import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { breakpoints, colors } from 'globalStyles'
import { useTranslation } from 'react-i18next'
import RadioButton from 'reusableComponents/RadioButton'
import { businessLocations, locations } from './config'

const HeaderStyledSpan = styled.span`
  font-weight: 600;
  float: left;
  padding: 5px 0 7px 0;
  margin-top: 16px;
`
const HorizontalLine = styled.hr`
  width: 100%;
  border: 0;
  border: 1px solid ${colors.grey_light};
  margin-top: 138px !important;
`
const Container = styled.div`
  height: 412px;
  @media screen and ${breakpoints.desktop} {
    height: 388px;
  }
  width: 100%;
  margin-bottom: 50px;
  margin-left: 5px;
  text-align: left;

  /*Radio Button Form Styles*/
  .form-check {
    height: 24px !important;
    height: auto;
    width: 100%;
    float: left;
  }
  .form-check-label {
    font-size: 14px !important;
  }
`
const StyledSpan = styled.span`
  font-weight: 600;
  float: left;
  padding: 5px 0 7px 0;
  margin-top: -8px;
`
const StyledHorizontalLine = styled.hr`
  width: 100%;
  border: 0;
  border: 1px solid ${colors.grey_light};
  margin-top: 248px !important;
`
const DropOffLocation = ({ onValueChangeHandler, selectedItem }) => {
  const { t } = useTranslation(['translation', 'termsAndConditions'])
  const [selectedLocation, setSelectedLocation] = useState(selectedItem)

  const onLocationChangeHandler = (event) => {
    onValueChangeHandler(event)
    setSelectedLocation(event.target.value)
  }

  return (
    <Container>
      <div>{t('my_preferences.drop_off_msg')}</div>
      <HeaderStyledSpan>{t('deliveryPreferencesSummary.residential_locations')}</HeaderStyledSpan>
      {locations.map((item) => (
        <RadioButton
          key={item.value}
          id={item.value}
          name="locations"
          value={item.value}
          label={t(item.label)}
          onChange={onLocationChangeHandler}
          selectedValue={selectedLocation}
          enabled={item.enabled}
        />
      ))}
      <StyledHorizontalLine />

      <StyledSpan>{t('deliveryPreferencesSummary.business_locations')}</StyledSpan>
      {businessLocations.map((item) => (
        <RadioButton
          key={item.value}
          id={item.value}
          name="businessLocations"
          value={item.value}
          label={t(item.label)}
          onChange={onLocationChangeHandler}
          selectedValue={selectedLocation}
          enabled={item.enabled}
        />
      ))}
      <HorizontalLine />
    </Container>
  )
}

DropOffLocation.propTypes = {
  selectedItem: PropTypes.string,
  onValueChangeHandler: PropTypes.func,
}

DropOffLocation.defaultProps = {
  selectedItem: '',
  onValueChangeHandler: null,
}

export default DropOffLocation
